import { createFileRoute } from "@tanstack/react-router";
import { HelpCenterPublicV4 } from "@/components/help/HelpCenterPublicV4";
import { useForceLightTheme } from "@/hooks/use-force-light-theme";

export const Route = createFileRoute("/docs")({
  component: DocsPage,
  validateSearch: (search: Record<string, unknown>) => ({
    article: typeof search.article === "string" ? search.article : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Centro de Ayuda — Structura Market" },
      { name: "description", content: "Guías prácticas para resolver tareas reales en Structura Market." },
      { name: "robots", content: "index, follow" },
    ],
  }),
});

function DocsPage() {
  useForceLightTheme();
  const { article } = Route.useSearch();
  return <HelpCenterPublicV4 articleId={article} />;
}
